import React from "react";

const TotalBusinessSVG = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.5H8.00667"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6663 4.50004V3.16671C10.6663 2.81309 10.5259 2.47395 10.2758 2.2239C10.0258 1.97385 9.68663 1.83337 9.33301 1.83337H6.66634C6.31272 1.83337 5.97358 1.97385 5.72353 2.2239C5.47348 2.47395 5.33301 2.81309 5.33301 3.16671V4.50004"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6663 9.16663C12.6882 10.4726 10.37 11.1688 7.99967 11.1688C5.62931 11.1688 3.31115 10.4726 1.33301 9.16663"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.333 4.5H2.66634C1.92996 4.5 1.33301 5.09695 1.33301 5.83333V12.5C1.33301 13.2364 1.92996 13.8333 2.66634 13.8333H13.333C14.0694 13.8333 14.6663 13.2364 14.6663 12.5V5.83333C14.6663 5.09695 14.0694 4.5 13.333 4.5Z"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TotalBusinessSVG;
